import { z } from 'zod'

export const createBookSchema = z.object({
  title: z.string().min(1, 'Title is required').max(500),
  author: z.string().min(1, 'Author is required').max(200),
  description: z.string().max(2000).optional(),
  coverUrl: z.string().url().optional().nullable(),
  openLibraryId: z.string().optional().nullable(),
  googleBooksId: z.string().optional().nullable(),
  isbn: z.string().optional().nullable(),
  pageCount: z.number().int().positive().optional().nullable(),
})

export const segmentPromptSchema = z.object({
  promptText: z.string().min(1).max(1000),
  promptOrder: z.number().int().min(1),
})

export const segmentSchema = z.object({
  segmentNumber: z.number().int().min(1),
  title: z.string().min(1).max(200),
  description: z.string().max(500).optional(),
  startPage: z.number().int().positive().optional().nullable(),
  endPage: z.number().int().positive().optional().nullable(),
  startChapter: z.number().int().positive().optional().nullable(),
  endChapter: z.number().int().positive().optional().nullable(),
  startPercent: z.number().min(0).max(100).optional().nullable(),
  endPercent: z.number().min(0).max(100).optional().nullable(),
  prompts: z.array(segmentPromptSchema).optional(),
})

export const configureSegmentsSchema = z.object({
  segments: z.array(segmentSchema).min(1),
})

export type CreateBookInput = z.infer<typeof createBookSchema>
export type SegmentPromptInput = z.infer<typeof segmentPromptSchema>
export type SegmentInput = z.infer<typeof segmentSchema>
export type ConfigureSegmentsInput = z.infer<typeof configureSegmentsSchema>
